import type { AnalyticsEventPayload } from '@atlaskit/analytics-next/AnalyticsEvent';

import { logger } from '../common/utils/logger';

type SurfaceAttributes = {
	principalEntityId: string;
	principalEntityType: string;
	relatedTopics: string[];
	location: string;
	sessionId?: string;
	searchQuery?: string;
};

export const onSurfaceShown = (surfaceAttributes: SurfaceAttributes): AnalyticsEventPayload => {
	try {
		return {
			action: 'shown',
			actionSubjectId: 'aiTopic',
			actionSubject: 'surface',
			eventType: 'track',
			attributes: {
				...surfaceAttributes,
			},
		};
	} catch (error) {
		logger.error({ error, functionName: 'onSurfaceShown' });
		return {};
	}
};

type EntityClickAttributes = {
	clickedEntityId: string;
	clickedEntityType: string;
	principalEntityId: string;
	principalEntityType: string;
	sessionId?: string;
	location: string;
	position?: number;
	shownAfterCardBodyExpanded?: boolean;
};

// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
export const onRelatedEntityClick = (
	entityClickAttributes: EntityClickAttributes,
): AnalyticsEventPayload => {
	try {
		return {
			action: 'clicked',
			actionSubjectId: 'aiTopic',
			actionSubject: 'relatedEntity',
			eventType: 'ui',
			attributes: {
				...entityClickAttributes,
			},
		};
	} catch (error) {
		logger.error({ error, functionName: 'onRelatedEntityClick' });
		return {};
	}
};

type ToggleMoreRelatedEntitiesClickedAttributes = {
	sessionId?: string;
	location: string;
	expanded: boolean;
};

// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
export const onToggleMoreRelatedEntitiesClick = (
	showMoreRelatedEntitiesClickedAttributes: ToggleMoreRelatedEntitiesClickedAttributes,
): AnalyticsEventPayload => {
	return {
		action: 'clicked',
		actionSubjectId: 'aiTopic',
		actionSubject: 'toggleMoreRelatedEntities',
		eventType: 'ui',
		attributes: {
			...showMoreRelatedEntitiesClickedAttributes,
		},
	};
};
